<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
    </svg>
    <SceneDialogue
      ref="main"
      :width="1"
      :tx="0" :ty="0.5"
      :bg="`transparent`"
      :fixedHeight="1"
      :styles="{color: 'white'}">
      <div :style="{height: '100%', overflow: 'scroll'}">
        <header>
          <hgroup>
            <h1>Max Littlesalt</h1>
            <h3>A Graphic Biography</h3>
          </hgroup>
          <p>
            This story is inspired by the voice of Charlie Littlesalt, Max Littlesalt’s son and Lithuania Denetso, Max Littlesalt’s granddaughter.
            <br><br>
            We at The ONWARD Project thank the extended Littlesalt Family for their generosity over many years sharing pieces of their personal histories with us.
          </p>
        </header>
        <div class="scroll-cta">
          <svg class="wheel absolute" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.05 50.88">
            <path d="M50.38,25.22c-4-1.2-8.23,1.71-10.26,5.35s-2.56,7.91-3.71,11.91A38.39,38.39,0,0,1,12.83,67.58c6.15,3.4,13,6,20,5.63S47,68.68,49.31,62c3.32-9.62-4.09-19.44-5.4-29.53-0.32-2.43-.17-5.18,1.53-7s5.33-1.59,6.06.76" transform="translate(-10.41 -23.36)"></path>
          </svg>
          <span class="block white scroll-cta-text sf bold" style="vertical-align: bottom;">SCROLL</span></span>
        </div>
        <main>
          <div class="image-attribution">
            <h2 class="title">Photography Captions</h2>
            Page 7 - Hand sketched map of Northern Arizona and Southern Utah, with region covered by the 1933 Rainbow Bridge-Monument Valley Expedition highlighted in red. From the Thorn L. Mayes Sr. papers, Accn 1189, Box 1. Special Collections and Archives. University of Utah, J. Willard Marriott. Salt Lake City, Utah.
            <br></br>
            Page 9 - Among the many records collected by researcher, Lithuania Denetso, were Max Littlesalt’s school records from Haskell Institute. In this letter from April 1, 1924, written by L.D. Smith of the Shonto Trading Post, Max’s father inquires with the school about sending Max home. From the National Archives and Records Administration.
            <br></br>
            Page 14 - Two stills made from moving image footage of Max Littlesalt breaking for refreshments at an Expedition camp. Behind him washing in a basin are Charles L. Walton and an unknown Expedition member. By Filmmaker Robert Kissack, 1933. From the Ansel Hall Collection, 2018 addition, Center of Southwest Studies at Fort Lewis College.
            <br></br>
            Page 15 - “Max Littlesalt, Leica, and ‘Casaba’ Camp in typical working pose.” “Leica” and “Casaba” were the nicknames of Expedition photographer, Clifford Bond, and Filmmaker, Charles Camp, respectively. Photograph by Torrey Lyons, courtesy of Andrew L. Christenson.
            <br></br>
            Page 17 - Shots from Expedition activities on Skeleton Mesa. Photograph by Robert Branstead. From the Ansel Hall Collection (P0081092), Center of Southwest Studies at Fort Lewis College.
            <br></br>
            Page 18- The ONWARD Project Image, 2017. Tsegi Canyon, Arizona.
            <br></br>
            Page 19 - Max Littlesalt (above animals) with two other unknown packers work to get the burrows up a rocky incline. Photograph by Clifford Bond. From the Ansel Hall Collection (P0084060), Center of Southwest Studies at Fort Lewis College.
            <br></br>
            Page 23 - Early Navajo Court of Indian Offenses Judges. Left to Right: Joe Duncan, Walter Juan, Chief Judge Tillman Hadley, Judge Zhealy Tso, Judge Maxwell Littlesalt, Alfred Hardy. Photographer Milton Snow. From a handout from the 2009 Annual Judicial Branch Conference, given to researcher Lithuania Denetso by an administrator at Kayenta Judicial District Court. Negative in the collection of the Navajo Nation Museum.
            <br></br>
            Page 24 - Max Littlesalt, Volunteer Foster Grandparent. Photo taken in Kayenta, Arizona in the early 1980s. Photographer not known. From research collection of Lithuania Denetso.
          </div>
          <div class="copyright">
            <span>Copyright 2020 The ONWARD PROJECT and the Denetso and Littlesalt Families</span>
          </div>
          <div class="social">
            <a target="_blank" href="https://onwardproject.org">onwardproject.org</a><br>
            <a target="_blank" href="https://instagram.com/onwardproject">@onwardproject</a><br>
            <a target="_blank" href="https://facebook.com/rbmveonward">facebook.com/rbmveonward</a><br>
            <a target="_blank" href="mailto:info@onwardproject.org">info@onwardproject.org</a>
          </div>
        </main>
      </div>
    </SceneDialogue>
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"].$el
    TweenLite.set(main, {opacity: 0})
    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 2, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()},
    touchRestart(e) {
      e.preventDefault()
      e.stopPropagation()
      this.restart()
    },
    restart(e) {
      this.$router.push("/")
    }
  }
}
</script>

<style lang="scss" scoped>
.content { padding: 0; }
header {
  text-align: center;
  padding-top: 2em;
  hgroup { font-size: 2em; }
  p { font-size: 1.5em; width: 80%; margin: 1em auto 0em; } }
main { width: 90%; margin: 0 auto; padding-bottom: 8em; }
.image-attribution {
  .title { margin-bottom: 0.5em; } }
.copyright {
  text-align: center; margin: 2em;
  span {
    background: rgba(250,250,250,1); color: black;
    display: inline-block; padding: 1em; } }
.social {
  text-align: center; line-height: 1.5em;
  a { color: white; text-decoration: underline; } }
.scroll-cta {
  text-align: center;
  transition: opacity 1s ease;
  z-index: 5;
  font-size: 1em;
  letter-spacing: .1em;
  color: #f2f2f2;
  margin: 1em auto 2.5em;
  position: relative;
  .wheel {
    width: 1em;
    transform: translateX(-50%) translateY(-100%) rotate(20deg);
    fill: #f2f2f2;
    left: 50%;
    top: 0px;
    position: absolute;
    animation: scroll-cta 1.33s infinite;
  }
  .scroll-cta-text {
    bottom: 0;
    left: 0;
    display: block;
    padding-top: 7em;
  }
}

@keyframes scroll-cta {
  0% {
    transform: translate(-50%,0) rotate(0deg);
    opacity: 0;
  }
  100% {
    transform: translate(-50%,420%) rotate(20deg);
    opacity: 1;
  }
}
</style>
